import * as React from 'react';
import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }) {
  return <div className={cn('sk-pulse animate-pulse rounded-md bg-slate-100 dark:bg-slate-800', className)} {...props} />;
}

export { Skeleton };
